import { gql } from '@apollo/client'
import { useCustomMutation } from 'utils/mutations'

// TICKET_UPDATE

const mutation = gql`
  mutation ticketUpdate(
    $id: ID!
    $attributes: UpdateTicketAttributesInput!
    $include_priority: Boolean = false
    $include_follow_up_data: Boolean = false
    $include_deliverables: Boolean = false
    $include_ticket_state: Boolean = false
    $include_assigned_to_id: Boolean = false
    $include_archived: Boolean = false
    $include_notes: Boolean = false
    $include_benefit_categories: Boolean = false
    $include_flag_id: Boolean = false
  ) {
    ticketUpdate(attributes: $attributes, id: $id) {
      id

      initial_interaction @include(if: $include_priority) {
        interaction_modality {
          priority
        }
      }

      follow_up @include(if: $include_follow_up_data) {
        notes
        scheduled_at
        subject
        ticket_id
      }

      deliverables @include(if: $include_deliverables) {
        id
        display_name
        group
        name
        description
        count
      }

      state @include(if: $include_ticket_state) {
        id
        code
        display_name
        priority
      }

      assigned_to @include(if: $include_assigned_to_id) {
        id
        full_name
      }

      flag @include(if: $include_flag_id) {
        id
        active
        display_name
      }

      archived @include(if: $include_archived)
      notes @include(if: $include_notes)
      benefit_categories @include(if: $include_benefit_categories)
    }
  }
`

export default function useTicketUpdate(successMessage = 'Ticket updated') {
  const { onMutate: onTicketUpdate, loading } = useCustomMutation({
    mutation,
    successMessage,
    responsePath: 'ticketUpdate'
  })
  return { onTicketUpdate, loading }
}
